import { useEffect } from "react";

const BASE = "Open Hands Healing Foundation";
const DOMAIN = "https://openhandshealing.org";

/**
 * Sets document title, meta description, and canonical URL for each page.
 */
export function usePageMeta(
  title: string,
  description: string,
  path: string = "/",
  opts: { image?: string; type?: string } = {}
) {
  const { image, type } = opts;
  useEffect(() => {
    document.title = title.includes(BASE) ? title : `${title} | ${BASE}`;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", description);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${DOMAIN}${path}`);

    // Update OG tags
    const ogUpdates: Record<string, string> = {
      "og:title": title.includes(BASE) ? title : `${title} | ${BASE}`,
      "og:description": description,
      "og:url": `${DOMAIN}${path}`,
      "og:type": type ?? "website",
      "og:image": image ?? `${DOMAIN}/og-image.jpg`,
    };
    for (const [prop, content] of Object.entries(ogUpdates)) {
      const tag = document.querySelector(`meta[property="${prop}"]`);
      if (tag) tag.setAttribute("content", content);
    }
    const twImg = document.querySelector('meta[name="twitter:image"]');
    if (twImg) twImg.setAttribute("content", image ?? `${DOMAIN}/og-image.jpg`);
  }, [title, description, path, image, type]);
}
